import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { LOGIN_URLS } from "../../api/LoginUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";

// Validation Schema
const schema = yup.object().shape({
  employeeId: yup.string().required("Employee ID is required"),
  epassword: yup
    .string()
    .matches(/^\d{6}$/, "PIN must be exactly 6 digits")
    .required("PIN is required"),
});

const TraineeLogin: React.FC = () => {
  const navigate = useNavigate();
  const { setUser } = useSiteContext();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [showPassword, setShowPassword] = useState(false);


  const handleLogin = async (data: any) => {
    let url = LOGIN_URLS.LOGIN;
    data["mode"] = "trainee";
    data["emailid"]= "test@gmail.com";
    const subscription = post(url, data, {
      requiresAuthorization: false,
    }).subscribe((response) => {
      reset();
      setUser(response.data);
      navigate("/exam/instructions")
    });

    return () => {
      subscription.unsubscribe();
    };

  };



  return (
    <div className="login-form">
      <form onSubmit={handleSubmit(handleLogin)}>
        <div className="field">
          <label className="label">Employee ID</label>
          <input className="input" type="text" {...register("employeeId")} />
          <p className="error">{errors.employeeId?.message}</p>
        </div>
        <div className="field smart-password-icon-field" >
      <label className="label">PIN (6 digits)</label>
      <input
        className="input"
        type={showPassword ? "text" : "password"}
        {...register("epassword")}
      />
      <i
        className={`password-icon smart-password-icon fa  ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
     
        onClick={() => setShowPassword(!showPassword)}
      ></i>
      <p className="error">{errors.epassword?.message}</p>
    </div>
        <button className="button is-primary is-fullwidth">Login</button>
      </form>
    </div>
  );
};

export default TraineeLogin;
